import React, { useCallback } from "react";
import { ChakraProps } from "@chakra-ui/react";
import { AsyncSearchProvider } from "./AsyncSearchProvider";
import AsyncSelect from "./AsyncSelect";
import useCraftingStations from "../../hooks/craftingStations/useCraftingStations";

interface SelectCraftingStationProps extends ChakraProps {
  value: string;
  setValue: (value: string) => void;
}

const SelectCraftingStation: React.FC<SelectCraftingStationProps> = ({ color, value, setValue, ...chakraProps }) => {
  const { isLoading, error, craftingStations = [] } = useCraftingStations();

  const handleSearch = useCallback(
    async (searchQuery?: string): Promise<[string, string][]> => {
      return craftingStations
        .filter(({ craftingStationId }) =>
          craftingStationId.toLowerCase().includes(searchQuery?.toLowerCase().trim() ?? "")
        )
        .map(({ craftingStationId }) => [craftingStationId, craftingStationId]);
    },
    [craftingStations]
  );

  return (
    <AsyncSearchProvider onSearchAsync={handleSearch}>
      <AsyncSelect
        selectedValue={value}
        setSelectedValue={setValue}
        color={color}
        title={"Crafting Station"}
        isLoading={isLoading}
        error={error}
        {...chakraProps}
      />
    </AsyncSearchProvider>
  );
};

export default SelectCraftingStation;
